import React from "react";

export const SkeletonCard = ({ className = "" }) => (
  <div className={`animate-pulse rounded-2xl bg-muted/70 ${className}`} />
);

export const SkeletonLine = ({ className = "" }) => (
  <div className={`animate-pulse rounded-md bg-muted/70 h-4 ${className}`} />
);

export const MetricSkeleton = () => (
  <div className="rounded-2xl border border-border bg-card p-6 space-y-4">
    <SkeletonLine className="w-24" />
    <SkeletonLine className="w-32 h-8" />
    <SkeletonLine className="w-20" />
  </div>
);

export const ChartSkeleton = () => (
  <div className="rounded-2xl border border-border bg-card p-6">
    <SkeletonLine className="w-40 mb-6" />
    <SkeletonCard className="h-64 w-full" />
  </div>
);
